import { tv } from 'tailwind-variants';

export const Card = tv({
  base: 'flex flex-col w-full group rounded-md gap-xl transition ease-in-out delay-100 shadow-level-1 p-5 bg-color-lightest items-center justify-evenly cursor-pointer hover:text-color-white relative',
  variants: {
    type: {
      modules: '',
    },
    color: {
      'embriologia-superior': 'hover:bg-disciplina-embriologia-superior',
      'farmacologia-superior': 'hover:bg-disciplina-farmacologia-superior',
      'fisiologia-superior': 'hover:bg-disciplina-fisiologia-humana-superior',
      'genetica-superior': 'hover:bg-disciplina-genetica-superior',
      'anatomia-superior': 'hover:bg-disciplina-anatomia-humana-superior',
      'bioquimica-superior': 'hover:bg-disciplina-bioquimica-superior',
      'histologia-superior': 'hover:bg-disciplina-histologia-humana-superior',
      'histologia-humana-superior': 'hover:bg-disciplina-histologia-humana-superior',
      'imunologia-superior': 'hover:bg-disciplina-imunologia-superior',
      'parasitologia-superior': 'hover:bg-disciplina-parasitologia-superior',
      'patologia-superior': 'hover:bg-disciplina-patologia-superior',
      'microbiologia-superior': 'hover:bg-disciplina-microbiologia-superior',
    },
  },
});

export const IconVariant = tv({
  base: 'stroke-0 group-hover:fill-card-color-default transition ease-in-out delay-100',
  variants: {
    type: {
      modules: 'h-16 w-16',
    },
    color: {
      'embriologia-superior': 'fill-disciplina-embriologia-superior',
      'farmacologia-superior': 'fill-disciplina-farmacologia-superior',
      'fisiologia-superior': 'fill-disciplina-fisiologia-humana-superior',
      'genetica-superior': 'fill-disciplina-genetica-superior',
      'anatomia-superior': 'fill-disciplina-anatomia-humana-superior',
      'bioquimica-superior': 'fill-disciplina-bioquimica-superior',
      'histologia-superior': 'fill-disciplina-histologia-humana-superior',
      'histologia-humana-superior': 'fill-disciplina-histologia-humana-superior',
      'imunologia-superior': 'fill-disciplina-imunologia-superior',
      'parasitologia-superior': 'fill-disciplina-parasitologia-superior',
      'patologia-superior': 'fill-disciplina-patologia-superior',
      'microbiologia-superior': 'fill-disciplina-microbiologia-superior',
    },
  },
});

export const TextVariant = tv({
  base: '',
  variants: {
    type: {
      title: 'md:line-clamp-5 text-center',
      paragraph: '',
    },
    hover: {
      white:
        'group-hover:text-card-color-default transition ease-in-out delay-100',
    },
  },
});
